import { createFileRoute } from "@tanstack/react-router";
import { DashboardPage } from "@/features/dashboards/pages";

export const Route = createFileRoute("/_app/dashboards/$dashboardId")({
  head: () => ({ meta: [{ title: "Dashboard · Malfak" }] }),
  component: DashboardRoute,
});

function DashboardRoute() {
  const { dashboardId } = Route.useParams();
  return <DashboardPage dashboardId={dashboardId} key={dashboardId} />;
}
